<!-- 交付在线 - 项目进度 lzj -->
<template>
    <div class="content">
        <div class="menu">
            <div class="title">项目资料库</div>
            <div class="menu_box">
                <template v-for="(item,index) in arrMenu">
                    <!-- <div v-if="index == 1 || index == 3 || index == 6 ? item.light : item.isShow " :key="index"-->
                    <div v-if="item.isShow && item.light" :key="index"
                         :data-num="item.num  > 9 ? '9+' : item.num "
                         @click="meunClick(index)"
                         :class="{'menu_item':true ,'menu_item_not':!item.light, 'red_dot':false}">
                        <!--  :class="{'menu_item':true ,'menu_item_not':!item.light, 'red_dot':item.num > 1 && item.light}">-->
                        <img :src="item.img" alt="">
                    </div>
                </template>
                <div class="vr-wrap" v-if="isBbtnVr!=0" @click="toVrLiNK">VR</div>
            </div>
        </div>
        <div :class="{'list_box':true,'list_box3':isShowShare,'list_box2': !arrMenu[0].isShow && !arrMenu[1].light}">
            <div class="list_title">项目日志</div>
            <div class="line_box">
                <div v-for="(item,index) in arrLog" :key="index" class="schedule_info">
                    <div class="schedule_title green" @click="touchUnfold(index)">
                        {{ item.title }}
                        <p>{{ item.isShow ? '收起' : '展开' }}</p>
                    </div>
                    <div :style="`overflow: hidden;height: ${item.isShow?'auto':'0'};`">
                        <div v-for="(item2,index2) in item.list" :key="index2" class="schedule_info_item">
                            <div class="schedule_time">
                                <div class="dot green_dot"></div>
                                <p>时间</p>
                                <p>{{ handleTime(item2.time) }}</p>
                            </div>
                            <div class="schedule_msg">
                                <p>
                                    {{ item2.text }}
                                    <template
                                        v-if="(item2.url && item2.url != '' &&  item.type == 1  && arrMenu[3].light)  || (item.type == 2 && arrMenu[2].light)  || (item.type == 3 && arrMenu[4].light && item2.process && item2.process > 0)  ">
                                        ， <span @click="touchLook(item.type,item2)">点击查看</span>
                                    </template>
                                </p>
                            </div>
                            <div v-if="item2.image && item2.image.length > 0" class="img_box">
                                <img v-for="(item3,index3) in item2.image" :key="item3.annotationid"
                                     :src="item3.new_filepath" @click="touchLookImg(item2.image,index3)" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'home':true,'home2':isShowShare}">
            <img @click="goHome" src="@/assets/images/user/house/home-jg.png" alt=""/>
        </div>
        <share v-if="isShowShare" :isFixed="true" ref="myShare"></share>
    </div>
</template>

<script>
import {getProjectLog} from "@/js/member/mynews/index.js";
import share from '../components/share.vue';
import {createLog} from "@/js/house";
import {ImagePreview} from "vant";
import {getRandomString} from "@/utils/stringUtils.js"

export default {
    components: {
        share
    },
    data() {
        return {
            log_request_uuid: '', //上一次记录日志的uuid
            logTimer: null,
            objProject: {},
            isShowShare: false,
            nContractId: 0, //合同id
            arrMenu: [{
                isShow: false,
                id: '',
                type_key: 'mapping', //勘察报告
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/menu1.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'plan',//项目方案书
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/menu2.png'),
            }, {
                isShow: true,
                type_key: 'contract_draft',//合同备忘
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/menu3.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'third_img',//3D设计方案
                num: 0,
                index: 3,
                light: false,
                img: require('/src/assets/images/user/housev2/menu4.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'process_detail',//施工报告
                num: 0,
                index: 11,
                light: false,
                img: require('/src/assets/images/user/housev2/menu5.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'project_group',//项目团队
                num: 0,
                index: 6,
                light: false,
                img: require('/src/assets/images/user/housev2/menu6.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'score',//竣工验收
                num: 0,
                index: 9,
                light: false,
                img: require('/src/assets/images/user/housev2/menu7.png'),
            }],
            arrLog: [], //日志
            isBbtnVr:0,//是否展示vr
        };
    },
    created() {
        // console.log('created')
        // if (this.$userHouse.state.usreHouserList && this.$userHouse.state.usreHouserList.project) {
        //     this.createLogFun('PV');
        // }
        // this.setLogTimer();

        this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
        this.$oInitData.memberInfo({
            h5_user_id: this.$storage.getStorage("user_id"),
        }).then((res) => {
            this.getBound();
        })
    },
    beforeDestroy(e) {
        // this.clearLogTimer();
    },
    methods: {
        toVrLiNK(){
            window.location.href='https://web.xiaohongwu.com/webapp/hotspot/index.html#/preview?p=s-b1202ed744ef4fd7926bc8fc9d1cdd6e&s=60cfbe47fbdfaefd8139b3438da7cfdc'
        },
        getBound() {
            this.$oInitData.memberInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {
                this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
                this.getUserHouse();
            }).catch((error) => {
                this.abnormal = false;
            });
        },
        // 绑定成功调用接口
        getUserHouse() {
            let objSam = this.$route.query;
            let data = {
                sampleroom: objSam.sampleroom || '',
                accountid: objSam.accountid || '',
                contractid: objSam.contractid || '',
                systemuserid: objSam.systemuserid || ''
            }
            if (data.sampleroom == 2 || data.sampleroom == 3) {
                setTimeout(() => {
                    this.isShowShare = true;
                    this.$refs.myShare.setShare();
                }, 200)
            }
            Promise.all([this.$userHouse.dispatch("getHouser", data), this.$store.dispatch("banner/getData", 7)]).then((res) => {
                this.isBbtnVr = this.$userHouse.state.usreHouserList.btn_vr
                let arrbtn = this.$userHouse.state.usreHouserList.btn; // 用户切换
                arrbtn.forEach((item) => {
                    // 统一图标点亮
                    // item.isdata = item.type_id == 0 || item.type_id == "" ? false : true;
                    //v2
                    this.arrMenu.forEach((item2) => {
                        if (item2.type_key == item.type_key) {
                            item2.num = Number(item.type_num || 0);
                            item2.id = item.type_id;
                            item2.light = item.type_id == 0 || item.type_id == "" ? false : true;
                        }
                    })
                });
                // 设置合同id
                this.$userHouse.state.usreHouserList.btn_cur.forEach((item) => {
                    if (item.type_key == "contract") {
                        this.nContractId = item.type_id;
                    }
                });
                this.objProject = this.$userHouse.state.usreHouserList.project
                this.getProjectLogFun(this.objProject.new_srv_projectmgnid);
            }).catch((error) => console.log(error));
        },
        getProjectLogFun(project_id) {
            getProjectLog({
                project_id: project_id
            }).then((res) => {
                let result = res.data.data.result;
                console.log('getProjectLog', result)
                let arrLog = [];
                arrLog.push({
                    title: '设计方案',
                    type: 1,
                    isShow: true,
                    list: result.design
                })
                arrLog.push({
                    title: '签订合同',
                    type: 2,
                    isShow: true,
                    list: result.contract
                })
                arrLog.push({
                    title: '施工在线',
                    type: 3,
                    isShow: true,
                    list: result.work
                })
                this.arrLog = arrLog;
                console.log('关闭load')
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            })
        },
        touchUnfold(index) {
            this.arrLog[index].isShow = !this.arrLog[index].isShow;
        },
        touchLook(type, item) {
            let objData = this.$route.query;
            let data = {
                sampleroom: objData.sampleroom || '',
                accountid: objData.accountid || '',
                contractid: objData.contractid || '',
                systemuserid: objData.systemuserid || '',
                sharePersonId:objData.sharePersonId
            }
            switch (type) {
                case 1:
                    this.$router.push({
                        path: "/member/v2/programme/index",
                        query: Object.assign({
                            url: item.url
                        }, data)
                    });
                    break;
                case 2:
                    this.$router.push({
                        path: "/member/v2/contract/survey",
                        query: Object.assign({
                            contractId: item.contract_id,
                            changeId: item.change_id
                        }, data),
                    });
                    break;
                case 3:
                    const {project} = this.$userHouse.state.usreHouserList;
                    this.$router.push({
                        path: '/member/v2/process/detail',
                        query: Object.assign({
                            id: item.process,
                            projectmgnid: project.new_srv_projectmgnid,
                            completed: 0,
                        }, data)
                    })
                    break;
            }
        },
        //查看全部项目点击查看图片
        touchLookImg(imgs, index) {
            let arrImg = imgs.map((e) => {
                return e.new_filepath
            })
            ImagePreview({
                images: arrImg,
                startPosition: index
            })
        },
        meunClick(index) {
            // 点击meun
            let item = this.arrMenu[index];
            if (!item.light) return;
            const {contract, project} = this.$userHouse.state.usreHouserList;
            let objData = this.$route.query;
            switch (item.type_key) {
                case 'mapping': //勘察报告
                    this.$router.push({
                        path: `/member/v2/project/mapping?contract_id=${
                            this.$userHouse.state.userInfor.default_contact ||
                            ""
                        }&id=${item.id}`,
                    });
                    break;
                case 'plan': //项目方案书
                    this.$router.push({
                        path: "/member/v2/project/plan",
                        query: {
                            reportId: item.id,
                        },
                    });
                    break;
                case 'third_img': //3D设计方案
                    console.log(item,"3D设计方案")
                    // window.location.href = item.id;
                    this.$router.push({path: "/member/v2/programme/index", query: objData});
                    break;
                case 'contract_draft': //合同备忘
                    let arr = this.arrLog[0].list;
                    if (arr.length > 0) {
                        this.$router.push({
                            path: "/member/v2/contract/survey",
                            query: {
                                sharePersonId:objData.sharePersonId,
                                contractId: this.nContractId,
                                changeId: arr.change_id,
                                sampleroom: objData.sampleroom || '',
                                accountid: objData.accountid || '',
                                contractid: objData.contractid || '',
                                systemuserid: objData.systemuserid || ''
                            },
                        });
                    } else {
                        this.$router.push({
                            path: "/member/v2/contract/survey",
                            query: {
                                sharePersonId:objData.sharePersonId,
                                contractId: this.nContractId, sampleroom: objData.sampleroom || '',
                                accountid: objData.accountid || '',
                                contractid: objData.contractid || '',
                                systemuserid: objData.systemuserid || ''
                            },
                        });
                    }
                    break;
                /*case 5:
                    this.$router.push({path: "/user/house/prospect"});
                    break;*/
                case 'project_group': //项目团队
                    this.$router.push({
                        path: "/member/v2/team/index", query: {
                            project_id: this.objProject.new_srv_projectmgnid,
                            sampleroom: objData.sampleroom || '',
                            accountid: objData.accountid || '',
                            contractid: objData.contractid || '',
                            systemuserid: objData.systemuserid || '',
                            sharePersonId:objData.sharePersonId,
                        }
                    });
                    break;
                /*case 7: //我要推荐
                    this.$router.push({path: "/user/house/recommend"});
                    break;*/
                case 'score': //竣工验收
                    // 需要给竣工评价页面传三个参数
                    //processName项目名称
                    //contract_id合同id
                    //topic_id 项目id

                    // window.location.href = `${window.location.origin}/user/house/finish?company_id=${project.new_id}&project_uuid=${project.new_srv_projectmgnid}&contract_id=${contract.new_contractid}&processName=${project.new_name}`;
                    window.location.href = `${window.location.origin}/member/v2/evaluate/finish?company_id=${project.new_id}&project_uuid=${project.new_srv_projectmgnid}&contract_id=${contract.new_contractid}}`;
                    break;
                /*case 10: //承诺书cover
                    let objcover = this.arrbtn.find((it) => {
                        return it.isdata && it.type_key == "cover";
                    });
                    if (!objcover) return;
                    this.$router.push({path: "/member/covernote/index"});
                    break;*/
                case 'process_detail': //施工报告
                    // window.location.href = `${window.location.origin}/member/process/index?projectmgnid=${project.new_srv_projectmgnid}`;
                    this.$router.push({
                        path: "/member/v2/process/index",
                        query: {
                            projectmgnid: project.new_srv_projectmgnid, sampleroom: objData.sampleroom || '',
                            accountid: objData.accountid || '',
                            contractid: objData.contractid || '',
                            systemuserid: objData.systemuserid || '',
                            sharePersonId:objData.sharePersonId,
                        },
                    });
                    // /member/process/index
                    break;
                case 'contact':
                    //我要评价
                    this.$router.push({
                        path: "/member/v2/ievaluate/evaluate",
                        query: {
                            company_id: project.new_id,
                            project_uuid: project.new_srv_projectmgnid,
                            contract_id: contract.new_contractid,
                            is_build_completed: project.is_build_completed,
                            is_completed: project.is_completed,
                            sampleroom: objData.sampleroom || '',
                            accountid: objData.accountid || '',
                            contractid: objData.contractid || '',
                            systemuserid: objData.systemuserid || '',
                            sharePersonId:objData.sharePersonId,
                        },
                    });
                    //总裁直通车
                    // window.location.href = 'https://smith.udesk.cn/im_client/?web_plugin_id=170594&group_id=281404';
                    break;
                default:
                    break;
            }
        },
        handleTime(time) {
            if (time) {
                let arr = time.split(' ')
                return arr[0].slice(0, 4) + '年' + arr[0].slice(5, 7) + '月' + arr[0].slice(8) + '日 ' + arr[1].slice(0, -3) + ' 更新'
            } else {
                return '--'
            }
            // return arr[0].slice(5, 7) + '月' + arr[0].slice(8) + '日 ' + arr[1]
        },
        goHome() {
            let Object = this.$route.query;
            if (Object.sampleroom) {// 1或者2
                this.$router.push({
                    path: `/member/v2/index/index`,
                    query: Object
                });
            } else {
                this.$router.push({
                    path: `/member/v2/index/index`,
                    query: Object
                });
            }
        },
        setLogTimer() {
            this.logTimer = setInterval(() => {
                if (this.$userHouse.state.usreHouserList && this.$userHouse.state.usreHouserList.project) {
                    this.createLogFun('LIVE')
                }
            }, 10 * 1000)
        },
        clearLogTimer() {
            if (this.logTimer != null) {
                clearInterval(this.logTimer);
                this.logTimer = null;
            }
        },
        createLogFun(type = '') {
            if (type == 'PV') {
                this.log_request_uuid = ''
            }
            let objProject = this.$userHouse.state.usreHouserList.project; // 用户信息
            let log_request_uuid = `uuid_${new Date().getTime()}_${getRandomString(4)}`;
            let data = {
                path: '/member/v2/schedule/index',
                project_id: objProject.new_srv_projectmgnid,
                rule_id: 0,
                project_name: objProject.new_name,
                from: 'H5',
                request_uuid: log_request_uuid,
                last_request_uuid: type == 'LIVE' ? this.log_request_uuid : '',
                type: type,
                share_id: 0
            }

            this.log_request_uuid = log_request_uuid;
            createLog(data)
        }
    },
};
</script>
<style lang="scss" scoped>
@import "./index";
</style>
